module.exports = __webpack_public_path__ + "static/media/header-background.190d2bab.png";